import { IntlShape } from 'react-intl';

export const shortcutsIds = {
  prev: 'quiz.shortcuts.key.prev',
  next: 'quiz.shortcuts.key.next',
  skip: 'quiz.shortcuts.key.skip',
  headerClick: 'quiz.shortcuts.header.click',
  confidence: 'quiz.shortcuts.header.confidence',
  high: 'quiz.shortcuts.key.high-confidence',
  medium: 'quiz.shortcuts.key.medium-confidence',
  low: 'quiz.shortcuts.key.low-confidence',
  headerCorrect: 'quiz.shortcuts.header.correct',
  correct: 'quiz.shortcuts.key.correct',
  incorrect: 'quiz.shortcuts.key.incorrect',
  headerSpacedRepetition: 'quiz.shortcuts.header.spaced-repetition',
  '1m': 'quiz.shortcuts.key.repeat-in-1',
  '10m': 'quiz.shortcuts.key.repeat-in-10',
  '1d': 'quiz.shortcuts.key.repeat-in-day',
  flag: 'quiz.shortcuts.key.flag',
  doNotRepeat: 'quiz.shortcuts.key.no-repeat',
  workspaces: 'quiz.shortcuts.header.workspaces',
  comment: 'quiz.shortcuts.key.comment',
  edit: 'quiz.shortcuts.key.edit',
  reset: 'quiz.shortcuts.header.reset',
} as const;

/**
 * Returns an array of shortcut items for the quiz.
 */
export const getShortcutItems = (intl: IntlShape) => [
  {
    isHeader: true,
    text: intl.formatMessage({
      id: 'quiz_settings.shortcut_heading.click_to_change_shortcut',
      defaultMessage: 'Click to change shortcut',
    }),
    id: shortcutsIds.headerClick,
  },
  {
    text: intl.formatMessage({
      id: 'quiz_settings.shortcut_prev',
      defaultMessage: 'Prev item',
    }),
    id: shortcutsIds.prev,
  },
  {
    text: intl.formatMessage({
      id: 'quiz_settings.shortcut_next',
      defaultMessage: 'Next item',
    }),
    id: shortcutsIds.next,
  },
  {
    text: intl.formatMessage({
      id: 'quiz_settings.shortcut_skip',
      defaultMessage: 'Skip item',
    }),
    id: shortcutsIds.skip,
  },
  {
    isHeader: true,
    text: intl.formatMessage({
      id: 'common.confidence',
      defaultMessage: 'Confidence',
    }),
    id: shortcutsIds.confidence,
  },
  {
    text: intl.formatMessage({
      id: 'common.high',
      defaultMessage: 'High',
    }),
    id: shortcutsIds.high,
  },
  {
    text: intl.formatMessage({
      id: 'common.medium',
      defaultMessage: 'Medium',
    }),
    id: shortcutsIds.medium,
  },
  {
    text: intl.formatMessage({
      id: 'quiz_settings.shortcut_low',
      defaultMessage: 'Low',
    }),
    id: shortcutsIds.low,
  },
  {
    isHeader: true,
    text: ' ',
    id: shortcutsIds.headerCorrect,
  },
  {
    text: intl.formatMessage({
      id: 'common.correct',
      defaultMessage: 'Correct',
    }),
    id: shortcutsIds.correct,
  },
  {
    text: intl.formatMessage({
      id: 'common.incorrect',
      defaultMessage: 'Incorrect',
    }),
    id: shortcutsIds.incorrect,
  },
  {
    isHeader: true,
    text: intl.formatMessage({
      id: 'quiz_settings.shortcut_heading.spaced_repetition',
      defaultMessage: 'Spaced repetition',
    }),
    id: shortcutsIds.headerSpacedRepetition,
  },
  {
    text: intl.formatMessage({
      id: 'quiz_settings.shortcut_1m',
      defaultMessage: 'Repeat in 1 min.',
    }),
    id: shortcutsIds['1m'],
  },
  {
    text: intl.formatMessage({
      id: 'quiz_settings.shortcut_10m',
      defaultMessage: 'Repeat in 10 min.',
    }),
    id: shortcutsIds['10m'],
  },
  {
    text: intl.formatMessage({
      id: 'quiz_settings.shortcut_1d',
      defaultMessage: 'Repeat in 1 day',
    }),
    id: shortcutsIds['1d'],
  },
  {
    text: intl.formatMessage({
      id: 'quiz_settings.shortcut_flag',
      defaultMessage: 'Flag',
    }),
    id: shortcutsIds.flag,
  },
  {
    text: intl.formatMessage({
      id: 'quiz_settings.shortcut_do_not_repeat',
      defaultMessage: 'Do not repeat',
    }),
    id: shortcutsIds.doNotRepeat,
  },
  {
    isHeader: true,
    text: intl.formatMessage({
      id: 'quiz_settings.shortcut_heading.workspaces',
      defaultMessage: 'Workspaces',
    }),
    id: shortcutsIds.workspaces,
  },
  {
    text: intl.formatMessage({
      id: 'quiz_settings.shortcut_comment',
      defaultMessage: 'Comment',
    }),
    id: shortcutsIds.comment,
  },
  {
    text: intl.formatMessage({
      id: 'quiz_settings.shortcut_edit',
      defaultMessage: 'Edit',
    }),
    id: shortcutsIds.edit,
  },
  {
    text: intl.formatMessage({
      id: 'quiz_settings.shortcut_reset',
      defaultMessage: 'Reset shortcuts to default',
    }),
    id: shortcutsIds.reset,
  },
];

export const SHORTCUTS_QUIZ_DEFAULT = {
  [shortcutsIds.prev]: 'ArrowLeft',
  [shortcutsIds.next]: 'ArrowRight',
  [shortcutsIds.skip]: 'Space',
  [shortcutsIds.high]: '3',
  [shortcutsIds.medium]: '2',
  [shortcutsIds.low]: '1',
  [shortcutsIds.correct]: '1',
  [shortcutsIds.incorrect]: '4',
  [shortcutsIds['1m']]: '7',
  [shortcutsIds['10m']]: '8',
  [shortcutsIds['1d']]: '9',
  [shortcutsIds.flag]: 'f',
  [shortcutsIds.doNotRepeat]: 'n',
  [shortcutsIds.comment]: 'c',
  [shortcutsIds.edit]: 'e',
};
